import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SessionData } from '../../types';
import moment from 'moment';

const initState = {
  loading: false,
  error: null as string | null,
  sessionData: null as SessionData | null,
  token: null as string | null,
  userRoleSelected: null as string | null,
  clientId: null as string | null,
  timeZoneValue: null as string | null,
  initialized: false,
  getDataSessionError: null as string | null,
};
export type AuthState = typeof initState;

const reducers = {
  // appLoaded
  appLoaded: (state: AuthState) => {
    state.initialized = true;
  },
  // Logout
  logout: (state: AuthState) => {
    state.error = null;
    state.sessionData = null;
    localStorage.removeItem('token');
    localStorage.removeItem('clientId');
  },
  // Get data session by token
  getDataSessionRequest: (
    state: AuthState,
    action: PayloadAction<{
      token: string;
      clientId: string;
      userRoleSelected?: string;
    }>
  ) => {
    // Always allow new token requests to override existing state
    state.loading = true;
    state.token = action.payload.token;
    state.clientId = action.payload.clientId;
    state.userRoleSelected = action.payload.userRoleSelected || null;
    state.getDataSessionError = null; // Clear any previous errors
  },
  getDataSessionSuccess: (
    state: AuthState,
    action: PayloadAction<SessionData>
  ) => {
    console.log('action.payload', action.payload);
    const sessionData = action.payload;
    state.loading = false;
    state.sessionData = sessionData;
    state.token = sessionData.Token?.TokenValue;
    state.initialized = true;
    state.timeZoneValue = sessionData.Client?.TimeZoneValue || 'UTC';

    // Set default timezone for moment.js
    moment.tz.setDefault(state.timeZoneValue || 'America/Lima');

    // Persist to localStorage
    localStorage.setItem('token', sessionData.Token?.TokenValue);
    localStorage.setItem('clientId', sessionData.Client?._id || '');
    localStorage.setItem('timeZoneValue', state.timeZoneValue);
    localStorage.setItem('currency', sessionData.Client?.CurrencySetting || '');
    localStorage.setItem(
      'clientSubscriptionStatus',
      sessionData.Client?.SubscriptionInfo?.Status || ''
    );
  },
  getDataSessionFailure: (state: AuthState, action: PayloadAction<string>) => {
    state.loading = false;
    state.getDataSessionError = action.payload;
    state.initialized = true;
    localStorage.removeItem('token');
    localStorage.removeItem('clientId');
    console.log(`getDataSessionFailure: ${JSON.stringify(action.payload)}`);
  },
  refreshDataSessionRequest: (state: AuthState) => {
    state.loading = false;
    state.getDataSessionError = null; // Clear any previous errors
  },
};

const mainSlice = createSlice({
  name: 'main',
  initialState: initState,
  reducers: reducers,
});

export const {
  appLoaded,
  logout,
  getDataSessionRequest,
  getDataSessionSuccess,
  getDataSessionFailure,
  refreshDataSessionRequest,
} = mainSlice.actions;

export const mainReducer = mainSlice.reducer;
